export { ApiClient } from "./ApiClient";
export { AggregatedCustomerDataService } from "./AggregatedCustomerDataService";
export { WorkflowService } from "./WorkflowService";
export { KeyMasterService } from "./KeyMasterService";
export { RedriveService } from "./RedriveService";
export { ScheduledEventsService } from "./ScheduledEventsService";
export { StepFunctionFailuresService } from "./StepFunctionFailuresService";

export type ServiceResult<T> = { status: "ok"; data: T } | { status: "error"; message: string };

export type JSONValue = string | number | boolean | null | JSONObject | JSONValue[];

export interface JSONObject {
  [key: string]: JSONValue;
}

export interface CustomerData {
  "rfd": JSONObject | null;
  "registration-request": JSONObject | null;
  "ab-registration": JSONObject | null;
  "ab-guest": JSONObject | null;
}

export interface CustomerDataHistory {
  "rfd": JSONObject[];
  "registration-request": JSONObject[];
  "ab-registration": JSONObject[];
  "ab-guest": JSONObject[];
}

export enum WorkflowStatus {
  SUCCEEDED = "SUCCEEDED",
  RUNNING = "RUNNING",
  FAILED = "FAILED",
  TIMED_OUT = "TIMED_OUT",
  ABORTED = "ABORTED",
}

export interface WorkflowExecution {
  executionArn: string;
  input: string;
  output?: string;
  startDate: string;
  stopDate?: string;
  status: WorkflowStatus;
  workflowName: string;
  workflowError?: { error: string; cause: string };
}

export interface RedriveResponse {
  executionArn: string;
  redriveDate: string;
  redriveCount: number;
}
